export const blog_tags_data = [
  {
    key: "1",
    tags: "Guide",
    addedOn: "25 May 2024",
    status: "Active",
  },
  {
    key: "2",
    tags: "Development",
    addedOn: "24 May 2024",
    status: "Active",
  },
  {
    key: "3",
    tags: "Education",
    addedOn: "15 Mar 2024",
    status: "Active",
  },
  {
    key: "4",
    tags: "Chances",
    addedOn: "21 Feb 2024",
    status: "Active",
  },
  {
    key: "5",
    tags: "Management",
    addedOn: "15 Feb 2024",
    status: "Inactive",
  },
  {
    key: "6",
    tags: "Sports",
    addedOn: "12 Feb 2024",
    status: "Active",
  },
  {
    key: "7",
    tags: "Guidance",
    addedOn: "14 Jan 2024",
    status: "Active",
  },
  {
    key: "8",
    tags: "Location",
    addedOn: "12 Jan 2024",
    status: "Active",
  },
  {
    key: "9",
    tags: "Hostel",
    addedOn: "16 Dec 2023",
    status: "Inactive",
  },
  {
    key: "10",
    tags: "Academic",
    addedOn: "12 Dec 2023",
    status: "Active",
  },
];
